import * as React from 'react'

import { BaseEventModel } from '@/app/models/baseEventModel'
import { BreakModel } from '@/app/models/breakModel'

import { useScene } from '../context/SceneContext'
import { useRestLanes } from '../context/LanesContext'

const color = '#0094FF'

export type BreakBlockProps = {
  breakModel: BreakModel
  index: number
}

const prepareTooltipInfo = (breakModel: BreakModel): BaseEventModel => ({
  startTime: breakModel.startTime,
  endTime: breakModel.formalRestEndDate,
  typeName: 'eventName.break',
  color,
})

export const BreakBlock: React.FC<BreakBlockProps> = React.memo(
  (props: BreakBlockProps) => {
    const scene = useScene()
    const { restLaneFor, restIsTop } = useRestLanes()
    const breakModel = props.breakModel

    const width = scene.widthOf(breakModel.startTime, breakModel.formalRestEndDate)
    const left = scene.timeToX(breakModel.startTime)
    const lane = restLaneFor(breakModel.startTime, breakModel.formalRestEndDate)
    const isTop = restIsTop(breakModel.startTime, breakModel.formalRestEndDate)

    return (
      <div
        className="tw-flex tw-flex-col tw-items-start tw-justify-end"
        style={{
          left,
          position: 'absolute',
          top: 0,
          bottom: 0,
          paddingBottom: scene.bottomPadding,
        }}
      >
        <div
          style={{
            background: color,
            borderColor: '#000000',
            pointerEvents: 'auto',
            width,
            height: 6,
            marginBottom: lane * 6,
            borderTopLeftRadius: isTop ? 3 : 0,
            borderTopRightRadius: isTop ? 3 : 0,
          }}
          data-tip={JSON.stringify(prepareTooltipInfo(breakModel))}
          data-for="eventTooltip"
        />
      </div>
    )
  },
)

BreakBlock.displayName = 'BreakBlock'
